import React, { useState, useEffect } from "react";
import styles from "./TemplateColorEditor.module.css";
import ColorPicker from "../Theme/ColorPicker";

const COLOR_FIELDS = [
  { key: "HeaderColor", label: "Header Background" },
  { key: "HeaderTextColor", label: "Header Text" },
  { key: "FooterColor", label: "Footer Background" },
  { key: "FooterTextColor", label: "Footer Text" },
  { key: "AddToCartColor", label: "Add to Cart Button" },
  { key: "AddToCartTextColor", label: "Add to Cart Text" },
  { key: "BuyNowColor", label: "Buy Now Button" },
  { key: "BuyNowTextColor", label: "Buy Now Text" },
  { key: "AccentColor", label: "Accent Color" },
  { key: "CardBgColor", label: "Card Background" },
  { key: "BodyBgColor", label: "Body Background" },
  { key: "BorderColor", label: "Border Color" },
  { key: "BadgeBgColor", label: "Badge Background" },
  { key: "BadgeTextColor", label: "Badge Text" },
  { key: "PriceColor", label: "Price Color" },
  { key: "OldPriceColor", label: "Old Price Color" },
];

function TemplateColorEditor({ template, storeTemplate, onSave }) {
  const [colors, setColors] = useState({});
  const [saving, setSaving] = useState(false);
  const [activePreset, setActivePreset] = useState("");

  useEffect(() => {
    // Initialize with store's custom colors or preset defaults
    const preset = template.colors?.find(
      (c) => c.name === storeTemplate?.activeColorPreset
    ) || template.colors?.find((c) => c.isDefault) || template.colors?.[0];

    const base = preset?.values || {};
    const custom = storeTemplate?.customColors || {};
    const merged = { ...base };
    for (const [k, v] of Object.entries(custom)) {
      if (v != null && v !== "") merged[k] = v;
    }
    setColors(merged);
    setActivePreset(storeTemplate?.activeColorPreset || preset?.name || "");
  }, [template, storeTemplate]);

  function handleColorChange(key, value) {
    setColors((prev) => ({ ...prev, [key]: value }));
  }

  function handlePresetSelect(preset) {
    if (preset.values) {
      setColors({ ...preset.values });
      setActivePreset(preset.name);
    }
  }

  async function handleSave() {
    setSaving(true);
    try {
      await onSave(colors);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className={styles.editor}>
      <h2 className={styles.title}>
        Customize Colors — {template.label}
      </h2>

      <div className={styles.presets}>
        <p className={styles.presetLabel}>Color Presets:</p>
        <div className={styles.presetRow}>
          {template.colors?.map((preset) => (
            <button
              key={preset.name}
              className={`${styles.presetChip} ${
                activePreset === preset.name ? styles.presetActive : ""
              }`}
              onClick={() => handlePresetSelect(preset)}
            >
              <span
                className={styles.presetDot}
                style={{ background: preset.values?.HeaderColor || "#333" }}
              />
              {preset.name}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.colorGrid}>
        {COLOR_FIELDS.map(({ key, label }) => (
          <div key={key} className={styles.colorItem}>
            <ColorPicker
              name={label}
              C_Color={colors[key] || "#ffffff"}
              SetColor={(val) => handleColorChange(key, val)}
            />
          </div>
        ))}
      </div>

      <div className={styles.saveRow}>
        <button
          className={styles.saveBtn}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Colors"}
        </button>
      </div>
    </div>
  );
}

export default TemplateColorEditor;
